<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      :hideOperate="true"
      @size-change="handleSizeChange"
      @on-selection-change="selectionChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="search"
          >搜索</el-button
        >
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
      </div>
      <template v-slot:expand>
        <div style="margin-bottom: 20px; vertical: middle">
          <p class="inline-p">操作列表：</p>
          <el-upload
            class="avatar-uploader"
            action="/file.api"
            accept=".xls, .xlsx"
            :show-file-list="false"
            :data="uploadData"
            :name="uploadName"
            :on-success="handleAvatarSuccess"
          >
            <el-button style="margin-left: 10px" type="primary"
              >批量导入</el-button
            >
          </el-upload>
          <el-button style="margin-left: 20px" type="text" @click="declare"
            >批量申报</el-button
          >
          <a
            style="margin-left: 20px"
            :href="templateUrl"
            download
            >导入模板下载</a
          >
          <el-button style="margin-left: 20px" @click="exportFunc"
            >导出</el-button
          >
          <el-button style="margin-left: 20px" @click="deleteFunc"
            >批量删除</el-button
          >
        </div>
      </template>
    </customize-page>
    <el-dialog title="导入信息预览" :visible="visible" @close="visible = false">
      <element-table
        headerClassName="stock-table"
        :data="importList"
        :columns="dialogColumns"
        :loading="loading"
        border
      ></element-table>
      <span
        style="line-height: 50px; font-size: 18px"
        v-if="importList.length === 0"
        >当前全部校验通过</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button
          type="primary"
          @click="importFunc"
          v-if="importList.length === 0"
          >导入</el-button
        >
        <el-button type="primary" @click="importFunc" v-if="importList.length"
          >继续导入</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";
import { formatDate } from "@/utils/common";
import { CONST_VD_IMGPREFIX } from "@/config/constant";
import ElementTable from "@/components/ElementTable";

import { mapState, mapActions } from "vuex";
import moment from "moment";

export default {
  components: {
    CustomizePage,
    ElementTable,
  },
  mixins: [Page],
  mounted() {
    this.fetch();
  },
  data() {
    return {
      templateUrl: process.env.BASE_URL + "templates/撤单申报模板.xlsx",
      form: [{ licensePlate: "", carrierCodes: [], carrierCodeDesc: [] }],
      importList: [],
      dialogColumns: [
        {
          title: "商户订单号",
          key: "merchantOrderNo",
          align: "center",
        },
        {
          title: "运单号",
          key: "mailNo",
          align: "center",
        },
        {
          title: "出库单编号",
          key: "bizId",
          align: "center",
        },
        {
          title: "清单编号",
          key: "invtNo",
          align: "center",
        },
        {
          title: "错误信息",
          key: "errorMsg",
          align: "center",
        },
      ],
      visible: false,
      loading: false,
      dataList: [],
      uploadData: {
        _aid: 401,
      },
      uploadName: "CPRODUCT_IMG.xlsx",
      columns: [
        {
          type: "selection",
          width: 50,
          align: "center",
          fixed: "left",
        },
        {
          title: "外部订单号",
          width: 200,
          key: "merchantOrderNo",
          align: "center",
        },
        {
          title: "撤单申报编号",
          width: 200,
          key: "revokeOrderNo",
          align: "center",
        },
        {
          title: "运单号",
          key: "mailNo",
          width: 200,
          align: "center",
        },
        {
          title: "清单编号",
          width: 150,
          key: "invtNo",
          align: "center",
        },
        {
          title: "区内企业",
          width: 120,
          key: "internalAreaCompanyName",
          align: "center",
        },
        {
          title: "审核状态",
          width: 120,
          key: "customsAuditStatus",
          align: "center",
          render: (h, param) => {
            if (!param.row && !param.row.customsAuditStatus) return;
            return <div>{this.statusDist[param.row.customsAuditStatus]}</div>;
          },
        },
        {
          title: "撤单回执",
          width: 120,
          key: "returnReason",
          align: "center",
        },
        {
          title: "创建时间",
          width: 200,
          key: "gmtCreateTime",
          align: "center",
          render: (h, param) => {
            let date = param.row.gmtCreateTime || "";
            return <p>{formatDate(date)}</p>;
          },
        },
        {
          title: "完成时间",
          width: 200,
          key: "finishTime",
          align: "center",
          render: (h, param) => {
            let date = param.row.finishTime || "";
            return <p>{formatDate(date)}</p>;
          },
        },
      ],
      filterObj: {
        popNos: "",
        popType: "",
        internalAreaCompanyName: "",
        checklistStatus: "",
        applyTime: [
          new Date(
            parseFloat(
              moment()
                .subtract(3, "day")
                .startOf("day")
                .format("x")
            )
          ),
          new Date(
            parseFloat(
              moment()
                .endOf("day")
                .format("x")
            )
          ),
        ],
        applyTime2: [],
      },
      currentRow: [],
      statusDist: {
        INIT: "初始化",
        CUSTOMS_AUDITING: "总署审核中",
        CUSTOMS_AUDIT_PASS: "总署审核通过",
        CUSTOMS_AUDIT_REJECT: "总署审核驳回",
      },
      pushDisabled: false,
    };
  },
  computed: {
    ...mapState("danding", {
      carrierAllList: "carrierAllList",
    }),
  },
  methods: {
    ...mapActions("danding", [
      "cancelLationsPageQuery",
      "batchDeclareRevokeOrder",
      "batchDeleteRevokeOrder",
      "importRevokeOrder",
      "previewRevokeOrderImport",
      "exportRevokeOrder",
    ]),
    // 导出
    exportFunc() {
      this.loading = true;
      const filterParams = Object.assign({}, this.getFilterParams());
      if (filterParams.applyTime != null) {
        filterParams.gmtCreateStart = new Date(
          filterParams.applyTime[0]
        ).getTime();
        filterParams.gmtCreateEnd = new Date(
          filterParams.applyTime[1]
        ).getTime();
        delete filterParams.applyTime;
      }
      if (filterParams.applyTime2 != null) {
        filterParams.finishTimeStart = new Date(
          filterParams.applyTime2[0] + " 00:00:00"
        ).getTime();
        filterParams.finishTimeEnd = new Date(
          filterParams.applyTime2[1] + " 23:59:59"
        ).getTime();
        delete filterParams.applyTime2;
      } else {
        delete filterParams.finishTimeStart;
        delete filterParams.finishTimeEnd;
      }
      this.exportRevokeOrder({
        request: {
          ...filterParams,
          // currentPage: 1,
          // pageSize: 9999
        },
      }).then((res) => {
        this.loading = false;
        if (res.value) {
          this.$alert("提交成功", "提示", {
            confirmButtonText: "确定",
            callback: (action) => {
              this.$router.push({ name: "download" });
            },
          });
        } else {
          this.$message.error("提交失败");
        }
      });
    },
    // 批量删除
    deleteFunc() {
      let revokeOrderNos = [];
      if (this.currentRow.length) {
        this.currentRow.map((item) => {
          // if (item.)
          revokeOrderNos.push(item.revokeOrderNo);
        });
      } else {
        this.$message.warning("请选择数据");
        return;
      }
      this.batchDeleteRevokeOrder({
        request: { revokeOrderNos },
      })
        .then((res) => {
          if (res.value) {
            this.$message.success("删除成功");
            this.fetch();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 申报
    declare() {
      let revokeOrderNos = [];
      if (this.currentRow.length) {
        this.currentRow.map((item) => {
          revokeOrderNos.push(item.revokeOrderNo);
        });
      } else {
        this.$message.warning("请选择数据");
        return;
      }
      this.batchDeclareRevokeOrder({
        request: { revokeOrderNos },
      })
        .then((res) => {
          if (res.failureList && res.failureList.length === 0) {
            this.$message.success("申报成功");
          } else {
            this.$message.error(`有${res.failureList.length}条数据申报失败`);
          }
          this.fetch();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    importFunc() {
      let list = this.importList.filter((item) => {
        return !item.errorMsg;
      });
      if (list.length === 0) {
        this.$message.warning("暂无有效数据");
        return;
      }
      this.importRevokeOrder({
        request: { customsRevokeOrderImportInfoList: list },
      })
        .then((res) => {
          if (res) {
            this.reset();
          }
          this.visible = false;
        })
        .catch((err) => {
          console.log(err);
          this.visible = false;
        });
    },
    // 导入数据
    handleAvatarSuccess(res, file) {
      let fileUrl =
        CONST_VD_IMGPREFIX.prefixImgUrl + res.content[0][this.uploadName];
      this.loading = true;
      this.previewRevokeOrderImport({ fileUrl }).then((res) => {
        this.loading = false;
        this.importList = res.customsRevokeOrderImportInfoList || [];
        if (this.importList.length === 0) {
          this.$message.warning("导入数据无效");
          this.visible = false;
        } else {
          this.visible = true;
        }
      });
    },
    // 分页加载退货订单列表
    fetch() {
      this.loading = true;
      const filterParams = Object.assign({}, this.getFilterParams());
      console.log(filterParams);
      if (filterParams.applyTime != null) {
        filterParams.gmtCreateTimeStart = moment(
          filterParams.applyTime[0]
        ).format("YYYY-MM-DD HH:mm:ss");
        filterParams.gmtCreateTimeEnd = moment(
          filterParams.applyTime[1]
        ).format("YYYY-MM-DD HH:mm:ss");
        delete filterParams.applyTime;
      } else {
        delete filterParams.gmtCreateTimeStart;
        delete filterParams.gmtCreateTimeEnd;
      }
      if (filterParams.applyTime2 != null) {
        filterParams.finishTimeStart = moment(
          filterParams.applyTime2[0]
        ).format("YYYY-MM-DD HH:mm:ss");
        filterParams.finishTimeEnd = moment(filterParams.applyTime2[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        delete filterParams.applyTime2;
      } else {
        delete filterParams.finishTimeStart;
        delete filterParams.finishTimeEnd;
      }
      let searchCondition = {
        request: {
          ...filterParams,
          currentPage: this.pagination.currentPage,
          pageSize: this.pagination.pageSize,
        },
      };
      this.cancelLationsPageQuery(searchCondition)
        .then((res) => {
          this.loading = false;
          this.dataList = res.revokeOrderItemList || [];
          const pageInfo = res.pageInfo || { totalCount: 0 };
          this.pagination.totalCount = pageInfo.totalCount;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    selectionChange(rows) {
      this.currentRow = rows;
    },
    getFormConfig() {
      const type = this.getFormItemType();
      return [
        {
          data: [
            {
              label: "审核状态",
              model: "customsAuditStatus",
              type: type.SELECT,
              props: {
                data: [
                  { value: "INIT", label: "初始化" },
                  { value: "CUSTOMS_AUDITING", label: "总署审核中" },
                  { value: "CUSTOMS_AUDIT_PASS", label: "总署审核通过" },
                  { value: "CUSTOMS_AUDIT_REJECT", label: "总署审核驳回" },
                ],
              },
            },
            {
              label: "区内企业",
              model: "internalAreaCompanyName",
              type: type.INPUT,
            },
            {
              label: "创建时间",
              model: "applyTime",
              type: type.DATETIME_RRANGE,
              className: "flex-form-item",
            },
            {
              label: "完成时间",
              model: "applyTime2",
              type: type.DATETIME_RRANGE,
              className: "flex-form-item",
            },
            {
              label: "",
              model: "popNos",
              type: type.CONTRAST_INPUT,
              className: "flex-form-item",
              props: {
                operator: "popType",
                data: [
                  {
                    value: "MAIL_NO",
                    label: "运单号",
                  },
                  {
                    value: "MERCHANT_ORDER_NO",
                    label: "商户订单号",
                  },
                  {
                    value: "INVT_NO",
                    label: "清单编号",
                  },
                ],
              },
            },
          ],
        },
      ];
    },
  },
};
</script>

<style lang="scss">
.row-div {
  padding-right: 30px;
  position: relative;
  button {
    position: absolute;
    right: 60px;
    bottom: 40px;
  }
}
.avatar-uploader {
  display: inline-block;
}
.inline-p {
  display: inline-block;
}
.inline-p span {
  color: #3399ff;
}

.el-dialog .el-dialog__body {
  padding-top: 0;
}
.el-button--text::after {
  background-color: #fff;
}
.dialog .el-form-item__label::before {
  content: "*";
  color: #ff3333;
  margin-right: 4px;
}
.el-dialog__footer {
  text-align: center;
}
.filter_con.filterUp .filter-form {
  height: auto;
  overflow: visible;
}
.el-form-item__content {
  width: 250px;
}
.filter_con .el-input {
  width: 100%;
}
</style>
